import styled from 'styled-components';
import { breakpoints } from './Variables';

export const LandingPageStyles = styled.div`
  section {
    min-height: calc(100vh - var(--navHeight));

    p {
      max-width: 54em;
      margin-left: auto;
      margin-right: auto;
    }

    &:not(.masterPlan) {
      h2 {
        font-size: var(--fsTitle1);
      }
    }
  }

  section.intro {
    position: relative;
    height: calc(100vh - var(--navHeight));
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    color: var(--peach);
    background-color: black;

    .hero {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .content {
      position: relative;
      z-index: 1;
      padding-top: 2em;
      text-align: center;

      h2 {
        font-size: var(--fsTitle1);
        margin-bottom: 2rem;
      }

      p {
        font-size: 1.5em;
        font-weight: bold;
        break-inside: avoid;
      }

      & > * {
        flex-shrink: 0;
      }

      .button {
        margin-top: 1rem;
        padding-left: 2em;
        padding-right: 2em;
        background-color: var(--peach);
        border-color: var(--peach);
        color: var(--black);
        letter-spacing: 1px;

        &:hover {
          color: var(--peach);
          background-color: transparent;
        }
      }

      @media (min-width: ${breakpoints.breakLg}) {
        padding-left: var(--col1);
        padding-bottom: 6rem;
        text-align: left;
        justify-content: flex-start;
        position: relative;

        p {
          font-size: 2em;
        }
        /* p:first-of-type {
          margin-bottom: 6em;
        } */

        .button {
          position: absolute;
          right: calc(50% - 6em);
          bottom: 2em;
        }
      }
    }

    iframe {
      width: 100vw;
      height: 56.25vw; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
      min-height: 100vh;
      min-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  section.masterPlan {
    padding: 0;
    position: relative;

    .sectionBigTitle {
      background-color: var(--peach);
      text-align: center;
      padding: var(--fsTitle2) 0;

      h2 {
        font-size: var(--fsTitle1);
      }

      .phase {
        font-size: var(--fsTitle2);
        text-transform: uppercase;

        p:not(:first-child) {
          display: none;
        }
      }
    }

    .quote {
      padding: 3rem var(--col1);
      background-color: var(--peach);
      text-align: center;

      p {
        max-width: 44em;
      }

      @media (min-width: ${breakpoints.breakLg}) {
        font-size: calc(var(--fsQuote) * 1.25);
      }
    }
  }

  section.property {
    background-color: var(--green);
    color: var(--peach);
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;

    h2 {
      text-align: center;
      padding: 3rem 0;
      margin-bottom: 0;
    }

    .cta {
      margin-bottom: 1rem;

      &:hover {
        background-color: var(--black);
        border-color: var(--black);
        color: var(--grey);
      }
    }

    @media (min-width: ${breakpoints.breakLg}) {
      padding-bottom: 4rem;

      h2 {
        padding: var(--fsHero) 0;
        font-size: var(--fsHero);
      }

      .intro {
        width: calc(50% - 1rem);
        flex-shrink: 0;

        p {
          margin-top: 0;
        }
      }

      .cta {
        margin-bottom: 0;
      }
    }
  }

  section.stayNow {
    background-color: var(--green);
    color: var(--peach);
    padding: 0;

    .hero {
      height: 80vh;
      position: relative;

      @media (min-width: ${breakpoints.breakMd}) {
        height: 80vh;
      }

      @media (min-width: ${breakpoints.breakLg}) {
        img {
          object-position: center 33%;
        }
      }

      .gatsby-image-wrapper {
        height: 100%;
      }
    }

    .slick-slide {
      height: 66vw;
    }

    // For reference only if we want to bring this back
    /* .heroText {
      position: absolute;
      left: 0;
      top: calc(50% - var(--fsTitle2));
      font-size: clamp(2.5rem, 6vw, var(--fsHero));
      text-align: center;
      text-transform: uppercase;
      width: 100%;
      padding: 0 2rem;
      color: var(--peach);
      font-family: Albertus, serif;
    } */

    h2 {
      padding: 2rem var(--col1);
      text-align: center;
      margin-bottom: 0;
    }

    .buttonWrapper {
      text-align: center;
      padding-bottom: 4rem;
    }

    .button {
      background-color: var(--peach);
      color: var(--green);

      &:hover {
        background-color: var(--green);
        border-color: var(--peach);
        color: var(--peach);
      }
    }

    .intro {
      padding: 0 var(--col1);
      padding-bottom: 1rem;

      // HACK: this should be an H3 or similar, but it's being rendered as a P
      & > .wrapper > :first-child {
        font-size: var(--fsTitle2);
        padding-bottom: 0;
        text-align: center;
        border-bottom: 1px solid var(--peach);

        @media (min-width: ${breakpoints.breakLg}) {
          text-align: left;
          margin-top: 0;
        }
      }
    }

    @media (min-width: ${breakpoints.breakLg}) {
      h2 {
        margin-top: 4rem;
      }

      .content {
        padding: 0 var(--col2) 6rem var(--col2);
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > * {
          width: calc(50% - 1rem);
        }

        .slick-slide {
          height: 20vw;
        }
      }

      .intro {
        padding: 0;
      }

      .buttonWrapper {
        text-align: left;
        margin-top: 2rem;
        padding-bottom: 0;
      }
    }
  }

  // TODO: break out this section?
  section.location {
    padding: 0;
    background-color: var(--peach);

    h2 {
      text-align: center;
      margin-top: 3rem;
    }

    .content {
      padding: 1rem var(--col1) 2rem var(--col1);
      max-width: 65em;
      margin: auto;
    }

    .map {
      position: relative;
      /* height: 68vw; */
      padding-top: 2rem;

      .gatsby-image-wrapper {
        position: absolute !important;
        top: 0;
        height: 100%;
        width: 100%;
      }

      .legend {
        position: relative;
        margin-bottom: 1rem;
        text-align: center;
        z-index: 1;

        .title {
          margin-bottom: 0;
        }

        p {
          margin-top: 0;
          text-align: center;
        }
      }
    }

    .block {
      margin-bottom: 2rem;

      p {
        text-align: justify;
        max-width: unset;
      }
    }

    .collapsibles {
      margin: 4rem 0;
      padding-top: 0.5rem;
      border-top: 1px solid black;
    }

    .collapsible {
      padding-bottom: 0;

      .title {
        padding-bottom: 0;
      }

      .block p {
        text-align: left;
      }
    }

    @media (min-width: ${breakpoints.breakLg}) {
      h2 {
        font-size: var(--fsHero);
        margin-bottom: 0.5em;
      }

      .legend.coordinates {
        font-size: var(--fsQuote);
        margin-top: 4rem;
      }

      .legend.name {
        font-size: var(--fsQuote);
        margin-bottom: calc(3 * var(--fsQuote));
      }

      .collapsible {
        .title {
          padding-top: 0.5rem;
          padding-bottom: 1rem;
        }

        .body {
          margin-top: 2rem;
        }

        // "Nearby towns" section
        &.towns {
          // Hack to put some space after "4 min" etc
          em {
            display: inline-block;
            margin-right: 1em;
          }
        }
      }
    }
  }

  section.comingSoon {
    background-color: var(--offWhite);
    padding: 0;
    min-height: unset;
    position: relative;

    .content {
      padding: 4rem var(--col1) 2rem var(--col1);
      text-align: center;
      display: flex;
      align-items: center;
      flex-direction: column;

      p {
        text-align: justify;
      }

      .button {
        margin-top: 2rem;
      }
    }

    h3 {
      text-align: center;
    }

    @media (max-width: 500px) {
      --heroVideoMobileHeight: 133vw;
      padding-top: var(--heroVideoMobileHeight);

      .hero:not(.expanded) {
        position: absolute;
        width: 100%;
        height: var(--heroVideoMobileHeight);
        top: 0;
        left: 0;
      }

      iframe {
        width: 100vw;
        height: 56.25vw; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
        min-height: 100vh;
        min-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  section.timeline {
    background-color: var(--offWhite);
    padding: 0 0 2rem 0;

    .slick-slider {
      margin-bottom: 2rem;
    }

    .slick-slide {
      height: 66vw;
    }

    .expanded .slick-slide {
      height: 100%;
    }

    @media (min-width: ${breakpoints.breakLg}) {
      min-height: unset;
      padding-bottom: 0;
    }
  }

  // Gradients
  .shadowBottom,
  .shadowTop {
    position: relative;
  }
  .shadowBottom::after,
  .shadowTop::before {
    display: block;
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 2.5rem;
    z-index: 1;
  }
  .shadowBottom::after {
    bottom: 0;
    background: linear-gradient(
      to bottom,
      transparent,
      rgba(0, 0, 0, 0.25) 100%
    );
  }
  .shadowTop::before {
    top: 0;
    background: linear-gradient(to top, transparent, rgba(0, 0, 0, 0.25) 100%);
  }
`;
